module.exports = __webpack_public_path__ + "img/supplements.7c2f225b.svg";